import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { lighten } from '@material-ui/core/styles';
import PeriodicReportForm from './PeriodicReportForm';
import CommonContainer from '../../../common/CommonContainer';
import { STANDARD_INPUT_WIDTH } from '../../../../const/chart-const';
import { BACKGROUND_WHITE, BLACK_COLOR } from '../../../../const/color-const';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  reportHeader: {
    paddingTop: theme.spacing(3),
    textAlign: 'center',
  },
  controls: {
    display: 'flex',
    justifyContent: 'center',
    '& .commonSelectField': {
      width: STANDARD_INPUT_WIDTH,
      backgroundColor: theme.palette.type === 'light' ? lighten(BACKGROUND_WHITE, 0.7) : BLACK_COLOR,
      maxHeight: 70,
      height: '100%',
    },
  },
}));

const PeriodicReport = ({ machines }) => {
  const classes = useStyles();
  const reportTitle = <FormattedMessage id="page.periodicReport.header" defaultMessage="Periodical report" />;
  
  return (
    <CommonContainer hAlign="center">
      <h1 className={classes.reportHeader}>{reportTitle}</h1>
      <PeriodicReportForm machines={machines} />
    </CommonContainer>
  );
};

const decorate = compose(
  connect(
    store => ({
      machines: store.user.machines,
    }),
  ));

export default decorate(PeriodicReport);